/**
 * Simple logger utility that wraps console methods
 * Can be extended to integrate with Sentry or other logging services
 */

const PREFIX = '[VideoPlayer]';

const logger = {
    log: (...args: unknown[]) => {
        if (process.env.NODE_ENV === 'development') {
            // eslint-disable-next-line no-console
            console.log(PREFIX, ...args);
        }
    },
    warn: (...args: unknown[]) => {
        // eslint-disable-next-line no-console
        console.warn(PREFIX, ...args);
    },
    error: (...args: unknown[]) => {
        // eslint-disable-next-line no-console
        console.error(PREFIX, ...args);
        // Could integrate with Sentry here if needed
        // try {
        //     const sentry = require('../sentry').initializeSentry();
        //     if (args[0] instanceof Error) {
        //         sentry.captureException(args[0]);
        //     } else {
        //         sentry.captureMessage(String(args[0]));
        //     }
        // } catch (e) {
        //     // Sentry not available
        // }
    },
    info: (...args: unknown[]) => {
        if (process.env.NODE_ENV === 'development') {
            // eslint-disable-next-line no-console
            console.info(PREFIX, ...args);
        }
    },
};

export default logger;

